var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"secure"}},[_c('navbar',{on:{"logout":_vm.logout}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }